import * as React from 'react';
import { Link, useI18next } from 'gatsby-plugin-react-i18next';
import tw, { styled } from 'twin.macro';

const Container = styled.div`
  ${tw`mt-auto mr-8 md:mr-0`}
`;

export default function LanguageSwitcher() {
  const { originalPath, language } = useI18next();

  return (
    <Container>
      <Link to={originalPath} language={language === 'de' ? 'en' : 'de'}>
        {language === 'de' ? 'en' : 'de'}
      </Link>
    </Container>
  );
}
